var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"top"},[_c('img',{attrs:{"src":_vm.topPicture,"alt":""}}),_c('div',{staticClass:"know-jiaxiao"},[_c('p',[_vm._v(_vm._s(_vm.topTitle))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }